import type { UserRole } from '@mairistem/finances-utils';
import React from 'react';
import ImportModal from '../../components/simulation/Outils/Import/ImportModal';
import type Simulation from '../../interfaces/simulation/simulation';
import BaseOutil from './BaseOutil';

class RecuperationDonneeConnexe extends BaseOutil {
	constructor() {
		super();
		this.code = 'RECUP_DONN_CONN';
		this.icon = {
			iconSet: 'Lucide',
			name: 'Share2',
		};
	}

	getTitle(simulation: Simulation): string {
		return this.isCompteAdministratif(simulation)
			? 'Alimenter les restes à réaliser à partir des logiciels métiers'
			: 'Alimenter les propositions à partir des logiciels métiers';
	}

	isEnabled(userRole: UserRole, simulation: Simulation): boolean {
		return super.isEnabled(userRole, simulation) && !simulation?.transfertCpta;
	}

	renderModal(
		simulation: Simulation,
		onClose: () => void,
		onValidate: () => void,
		open: boolean,
	) {
		return (
			<ImportModal
				onClose={onClose}
				onValidate={onValidate}
				open={open}
				simulation={simulation}
				hasCa={this.isCompteAdministratif(simulation)}
			/>
		);
	}
}

export default RecuperationDonneeConnexe;
